module.exports = __webpack_public_path__ + "img/onboarding-active.82243a3c.svg";